module.exports = __webpack_public_path__ + "media/img/event/sbt-header-2-ca1dad9e0d27259c941e183ede1d6d11.jpeg";